// extracted by mini-css-extract-plugin
export default {"button":"Button-module__button___vXE6E"};